import type { ResolvedFilters } from "@/services/mergeTags";

/**
 * Formats a merge-tag chip's visible label, appending an if/else fallback as
 * `Label / fallback` verbatim, and ` ★` when a rating shows as stars. Shared
 * so the editor chip and read-only surfaces render identical text.
 */
export function formatMergeTagChipLabel(
  label: string,
  filters?: ResolvedFilters,
): string {
  const shown = filters?.ratingDisplay === "stars" ? `${label} ★` : label;
  const fallback =
    typeof filters?.default === "string" && filters.default.length > 0
      ? filters.default
      : undefined;
  if (!fallback) return shown;
  return `${shown} / ${fallback}`;
}
